export class IncidentApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
  ) {
    super(message);
    this.name = 'IncidentApiError';
  }
}
